import { render, staticRenderFns } from "./Remarks.vue?vue&type=template&id=f4c87d8e&"
import script from "./Remarks.vue?vue&type=script&lang=ts&"
export * from "./Remarks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports